export const DB_DRIVE_NAME = 'DriveDatabase';
// TODO: remove once all users have migrated past v2, including the service workers (keep for explicit Dexie migration chain - do not touch as long that it is used).
export const DB_DRIVE_SCHEMA_V2 = {
  requests: '&entity.id,retry.status',
  photoRequests: '&photo.id,retry.status',
  protocol: '&id,transportId,formValue,photos,updatedAt,publishedAt'
};
// TODO: remove once all users have migrated past v3, including the service workers (keep for explicit Dexie migration chain - do not touch as long that it is used).
export const DB_DRIVE_SCHEMA_V3 = {
  ...DB_DRIVE_SCHEMA_V2,
  counterPartyNotes: '&transportId'
};
export const DB_OFFLINE_QUEUE_NAME = 'OfflineQueueDB';
export const DB_OFFLINE_QUEUE_SCHEMA_V3 = {
  httpRequests: '++id, type, endpoint, retryTotal, retryLatestDate',
  photoRequests: '++id, retryTotal, retryLatestDate',
  protocolPhotoUploads: 'transportInternalId',
  issuePhotoRequests: '++id, tourStopActionId, issueReportId, retryTotal, retryLatestDate',
  issuePhotoUploadData: 'tourStopActionId',
  jwt: ''
};
export const DB_OFFLINE_QUEUE_SCHEMA_V4 = {
  issuePhotoRequests: null,
  issuePhotoUploadData: null
};

export const OFFLINE_RETRYABLE_STATUS_CODES = [0, 404, 500, 501, 502, 503, 504, 505, 506, 507, 508, 510, 511];
